import { createStore } from 'vuex'

import jobsList from '../data.json';

export default createStore({
  state() {
    return {
      myData: [],
      filterList: [],
      listSearch: [],
      newList: [],
    }
  },
  getters: {
    getList(state) {
      return state.myData;
    },

    getFilteredList(state) {
      return state.filterList;
    }
  },
  mutations: {
    fillData(context, payload) {
      return context.myData = [...payload];
    },

    getListToFilter(context, payload) {
      context.listSearch.push(payload)
      return context.filterList = [...new Set(context.listSearch)];
    }

  },
  actions: {
    getJobList(context) {

      if (jobsList.length < 1) {
        const error = new Error('Error to load list')
        throw error;
      }
      context.commit('fillData', jobsList)
    },

    addItems(context, payload) {

      const item = payload.target.closest("button").innerText;

      context.commit('getListToFilter', item);
      
    },

    filterItems() {

     // this.state.myData = [];
      this.state.newList = [];

      if (this.state.filterList.length > 0) {
        jobsList.map((job) => {
          let filter = [job.role, job.level, ...job.languages, ...job.tools];
          if (this.state.filterList.every((el) => filter.indexOf(el) !== -1)) {
            return this.state.newList.push(job);
          }
        });
        this.state.myData = [... new Set(this.state.newList)];

      } else {
        return this.state.myData = [...new Set(jobsList)];
      }
    },

    removeItem(context, payload) {
      context.state.listSearch = [...new Set(this.state.listSearch)];
      context.state.listSearch.splice(payload.index, 1)
      context.state.filterList.splice(payload.index, 1);
      context.dispatch('filterItems');
     
    },

    removeAll(context) {
      context.state.filterList = [];
      context.state.listSearch = [];
      context.state.newList = [];
      context.dispatch('filterItems');
    },
  },
  modules: {
  }
})
